module.exports = __webpack_public_path__ + "img/banner6.a56bb280.jpg";